<template>
    <button-base styleType="primary">
        <slot></slot>
    </button-base>
</template>
